import { z } from "zod";

import { pendingEmailActionSchema } from "@signalist/shared-types";

import {
	CompanyCategoryResultsSchema,
	PersonaCategoryResultsSchema,
	ProspectPendingEmailSchema,
} from "../../Apollo/schema/get-people";

/**
 * The email hover's facts an edit answers with (PREC-4262): when the address was set, and the
 * caller's company's provenance of the current address (null when unknown). Absent on an older API.
 */
export const EmailFactsUpdateSchema = z.object({
	emailSetAt: z.string().nullable().optional(),
	emailSource: z.string().nullable().optional(),
	emailVerifiedAt: z.string().nullable().optional(),
	emailVerificationResult: z.string().nullable().optional(),
});

export type EmailFactsUpdate = z.infer<typeof EmailFactsUpdateSchema>;

export const ProspectUpdateSchema = EmailFactsUpdateSchema.extend({
	id: z.number(),
	updateProspectDto: z.object({
		name: z.string().optional(),
		firstName: z.string().optional(),
		middleName: z.string().optional(),
		lastName: z.string().optional(),
		bookingLink: z.string().optional(),
		seniority: z.string().optional(),
		scorePersonaCategoryResult: PersonaCategoryResultsSchema.nullable().optional(),
		scoreCompanyCategoryResult: CompanyCategoryResultsSchema.nullable().optional(),
		jobTitleToSeniority: z
			.object({
				seniority: z.string(),
				jobTitle: z.string(),
				id: z.number(),
			})
			.optional(),
		phone: z.string().optional(),
		email: z.string().optional(),
		linkedinUrl: z.string().optional(),
		gender: z.string().nullable().optional(),
	}),
});

export type ProspectUpdate = z.infer<typeof ProspectUpdateSchema>;

export const ProspectEmailUpdateSchema = z.array(
	z.object({
		id: z.number(),
		emailStatus: z.string(),
	})
);

export type ProspectEmailUpdate = z.infer<typeof ProspectEmailUpdateSchema>;

export const ProspectPhoneUpdateSchema = z.array(
	z.object({
		id: z.number(),
		phoneStatus: z.string(),
	})
);

export type ProspectPhoneUpdate = z.infer<typeof ProspectPhoneUpdateSchema>;

export const PendingEmailUpdateSchema = EmailFactsUpdateSchema.extend({
	id: z.number(),
	pendingEmailId: z.number(),
	action: pendingEmailActionSchema,
	email: z.string().nullable().optional(),
	emailStatus: z.string().nullable().optional(),
	pendingEmails: z.array(ProspectPendingEmailSchema),
});

export type PendingEmailUpdate = z.infer<typeof PendingEmailUpdateSchema>;
